import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styles = {};

const enhance = compose();

// const tableHead = enhance(({ roles }) => {
const tableHead = enhance(() => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>Id</TableCell>
        <TableCell>決済ID</TableCell>
        <TableCell>ユーザーメールアドレス</TableCell>
        <TableCell>金額</TableCell>
        <TableCell>DBに保存状態</TableCell>
        <TableCell>作成日</TableCell>
        <TableCell>更新日</TableCell>
        <TableCell />
        <TableCell />
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(tableHead);
